import { createContext } from 'react';
import type { PlayerChartContextType } from '../types';

export const PlayerchartContext = createContext<PlayerChartContextType | undefined>(undefined);

export const playerChartContexts = new Map<string, React.Context<PlayerChartContextType | undefined>>();

export const getPlayerChartContext = (instanceId: string) => {
  if (!playerChartContexts.has(instanceId)) {
    playerChartContexts.set(instanceId, createContext<PlayerChartContextType | undefined>(undefined));
  }
  const context = playerChartContexts.get(instanceId);
  if (!context) {
    throw new Error(`Could not create context for instanceId: ${instanceId}`);
  }
  return context;
};